<script lang="ts">
  import { sidebarOpen } from '$utils/ui';
  import { scrollToActiveRace } from './race/RaceList.svelte';

  function toggleSidebar() {
    sidebarOpen.update((v) => !v);
    setTimeout(() => {
      $scrollToActiveRace();
    }, 50);
  }
</script>

<button
  class="cursor-pointer self-center rounded-lg p-2 hover:bg-gray-100 lg:hidden"
  on:click|preventDefault={toggleSidebar}
  on:keypress|preventDefault={toggleSidebar}
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="h-6 w-6 hover:rotate-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    />
  </svg>
</button>
